import axios from 'axios';
import { buildApiUrl } from '../config/api';

// Configuration centrale d'axios
const api = axios.create({
  baseURL: buildApiUrl('/'),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor pour ajouter le token d'authentification
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('@TikodAdmin:token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token invalide ou expiré
      localStorage.removeItem('@TikodAdmin:token');
      localStorage.removeItem('@TikodAdmin:user');
      delete axios.defaults.headers.common['x-auth-token'];

      // Redirect vers login si on n'est pas déjà sur la page de login
      const currentPath = window.location.pathname;
      if (currentPath !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
